import { render, staticRenderFns } from "./modal-infografia.vue?vue&type=template&id=5b6e5e41&scoped=true&"
import script from "./modal-infografia.vue?vue&type=script&lang=js&"
export * from "./modal-infografia.vue?vue&type=script&lang=js&"
import style0 from "./modal-infografia.vue?vue&type=style&index=0&id=5b6e5e41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e5e41",
  null
  
)

export default component.exports